import { RSAA } from 'redux-api-middleware';
import getCountriesURL from 'url-constructors/getCountriesURL';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';
import { ICountryFlagProps } from 'types/shared';

export const REQUEST = 'opus/countries/REQUEST';
export const SUCCESS = 'opus/countries/SUCCESS';
export const FAILURE = 'opus/countries/FAILURE';

type CountriesActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

export interface ICountriesState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: ICountryFlagProps[];
}

interface ICountriesAction {
  type: CountriesActionTypes;
  payload: ICountryFlagProps[];
}

export const initialState: ICountriesState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: [],
};

function reducer(
  state: ICountriesState = initialState,
  action: ICountriesAction
): ICountriesState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadCountries(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { countries } = getState();

    return await dispatch({
      [RSAA]: {
        bailout: countries.pending || countries.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: ICountriesAction,
              state: ICountriesState,
              res: any
            ): Promise<ICountryFlagProps[]> {
              const json = await res.json();
              return json.data;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: getCountriesURL(),
      },
    });
  };
}

export { loadCountries };
export default reducer;
